import angular from 'angular';
import syncOrderModal from '../sync-order-modal/sync-order-modal.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalDriver from '../../shared/components/modal-driver/modal-driver.view.html';

let inject = [
    '$scope',
    'TrackingService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    'Pagination',
    'SessionService',
    '$window',
    'ngAuthSettings',
    '$stateParams',
    'OrdersService'
];

class TrackingController {
    constructor($scope,
                TrackingService,
                $state,
                $rootScope,
                SharedService,
                $uibModal,
                $timeout,
                Pagination,
                SessionService,
                $window,
                ngAuthSettings,
                $stateParams,
                OrdersService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ngAuthSettings = ngAuthSettings;
        this.$uibModal = $uibModal;
        this.TrackingService = TrackingService;
        this.Pagination = Pagination;
        this.SharedService = SharedService;
        this.loadingTracking = true;
        this.SessionService = SessionService;
        this.$window = $window;

        this.orderId = this.$stateParams.orderId;
        this.orderData = {};
        this.trackingData = {};
    }

    $onInit() {
        this.getOrder(this.orderId);
    }

    getOrder(orderId) {


        let globals = this.shCtrl.globals;
        let userId = '';
        try {
            userId = globals.currentUser.userId;
        }
        catch (e) {
        }
        let sellerId = '';
        try {
            sellerId = globals.currentUser.sellerId;
        }
        catch (e) {
        }

        // Send the request
        this.TrackingService.getOrderById({
            'orderId': orderId,
            'typeOrders': '',
            'userId': userId,
            'sellerId': sellerId
        }).then(response => {

            if (!response.error) {
                this.orderData = response.data.order;
                this.orderData.totalPesoItems = 0;
                this.orderData.cantidadTotalCanasta = 0;
                response.data.order.items.forEach(val => {
                    this.orderData.totalPesoItems += val.cantidad * val.peso_embalaje;
                    this.orderData.cantidadTotalCanasta += val.cantidad;
                });

                this.gettracking(this.orderData.id);

            }
        }).catch(reason => {
            this.loadingTracking = false;
            alert('Ha ocurrido un error al obtener los datos');
        });
    }

    gettracking(orderId){
    
        this.TrackingService.tracking(orderId).then(response=>{
            
            this.trackingData = response.data;
            this.loadingTracking = false;

        }).catch(reason=>{
            alert('Ha ocurrido un error al obtener los datos del tracking');
        });
    }
}

TrackingController.$inject = inject;

export default TrackingController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/tracking/tracking.controller.js
 **/